webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_PagesView__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_PagesView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_PagesView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_HomeView__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_HomeView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_HomeView__);






__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    redirect: '/pages/'
  }, {
    path: '/pages',
    component: __WEBPACK_IMPORTED_MODULE_2__views_PagesView___default.a,
    children: [{
      path: '',
      redirect: '/pages/home'
    }, {
      path: 'home',
      name: 'HomeView',
      component: __WEBPACK_IMPORTED_MODULE_3__views_HomeView___default.a
    }]
  }, {
    path: '*',
    redirect: '/pages/'
  }]
}));

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_docs__ = __webpack_require__(23);





__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    docs: __WEBPACK_IMPORTED_MODULE_2__modules_docs__["a" /* default */]
  }
}));

/***/ }),
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(62)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(79),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */,
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_scroll_behavior__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_scroll_behavior___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_scroll_behavior__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_normalize_css__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_normalize_css__);









__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vue_scroll_behavior___default.a, { router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */] });
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading___default.a, {
  system: {
    throttleLimit: 5000
  }
});

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_superagent__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_superagent__);



var state = {
  perPage: 200,
  page: 1,

  _data: [],
  data: [],
  dataset: '',
  datasets: ['WNLI', 'QNLI', 'QQP', 'RTE', 'SST-2', 'STS-B', 'DIAGNOSTICS', 'DPR', 'CMRC', 'DRCD', 'CB', 'COPA', 'MultiRC', 'RTE-diagnostic', 'WiC', 'BoolQ', 'ReCoRD', 'RACE', 'SciTail', 'Winogrande', 'swag']
};

var datasetUri = {
  'WNLI': 'WNLI/dev.tsv',
  'QNLI': 'QNLI/dev.tsv',
  'QQP': 'QQP/dev.tsv',
  'RTE': 'RTE/dev.tsv',
  'SST-2': 'SST-2/dev.tsv',
  'STS-B': 'STS-B/dev.tsv',
  'DIAGNOSTICS': 'diagnostics/diagnostic-full.tsv',
  'DPR': 'DPR/dpr_data.txt',
  'CMRC': 'CMRC/cmrc2018_dev.json',
  'DRCD': 'DRCD/DRCD_dev.json',
  'CB': 'CB/val.jsonl',
  'COPA': 'COPA/val.jsonl',
  'MultiRC': 'MultiRC/val.jsonl',
  'RTE-diagnostic': 'RTE-diagnostics/AX-g.jsonl',
  'WiC': 'WiC/val.jsonl',
  'WSC': 'WSC/val.jsonl',
  'BoolQ': 'BoolQ/val.jsonl',
  'ReCoRD': 'ReCoRD/val.jsonl',
  'RACE': 'RACE/dev-middle.jsonl',
  'SciTail': 'SciTail/scitail_1.0_dev.tsv',
  'Winogrande': 'winogrande/dev.jsonl',
  'swag': 'swag/val_full.csv'
};

var parseTSV = function parseTSV(content) {
  return content.split('\n').map(function (row) {
    return row.split('\t');
  });
};

var parseCSV = function parseCSV(content) {
  return content.split('\n').map(function (row) {
    return row.split(',');
  });
};

var parseJSON = function parseJSON(content) {
  return JSON.parse(content)['data'];
};

var parseJSONL = function parseJSONL(content) {
  return content.split('\n').filter(function (row) {
    return row.length > 1;
  }).map(JSON.parse);
};

var parseDPR = function parseDPR(content) {
  return content.split('\n\n').map(function (rows) {
    return rows.split('\n').map(function (col) {
      return col.split(': ')[1];
    });
  });
};

var mutations = {
  loadDataset: function loadDataset(state, payload) {
    state.page = 1;
    var format = datasetUri[payload.name].split('.')[1];

    if (payload.name.indexOf('DPR') > -1) {
      state._data = parseDPR(payload.res);
    } else if (format.indexOf('tsv') > -1) {
      state._data = parseTSV(payload.res);
    } else if (format.indexOf('csv') > -1) {
      state._data = parseCSV(payload.res);
    } else if (format.indexOf('jsonl') > -1) {
      state._data = parseJSONL(payload.res);
    } else if (format.indexOf('json') > -1) {
      state._data = parseJSON(payload.res);
    } else {
      state._data = parseTSV(payload.res);
    }

    state.data = state._data.slice(0, state.page * state.perPage);
    state.dataset = payload.name.split('/')[0].toUpperCase();
    state.page += 1;
  },
  loadMoreRows: function loadMoreRows(state, payload) {
    state.data = state._data.slice(0, state.page * state.perPage);
    state.page += 1;
  },
  querySentence: function querySentence(state, payload) {
    if (payload.queryStr.length < 3) return;
    state.data = state._data.filter(function (row) {
      return row.filter(function (col) {
        return col.indexOf(payload.queryStr) > -1;
      }).length > 0;
    });
  }
};

var actions = {
  loadDataset: function loadDataset(_ref, payload) {
    var commit = _ref.commit,
        state = _ref.state;

    if (state.noMore) return;
    __WEBPACK_IMPORTED_MODULE_0_superagent___default.a.get('./static/data/' + datasetUri[payload.name]).end(function (err, res) {
      if (!err) {
        commit({
          type: 'loadDataset',
          res: res.text,
          name: payload.name
        });
      }
    });
  },
  loadMoreRows: function loadMoreRows(_ref2, payload) {
    var commit = _ref2.commit,
        state = _ref2.state;

    commit({
      type: 'loadMoreRows'
    });
  },
  querySentence: function querySentence(_ref3, payload) {
    var commit = _ref3.commit,
        state = _ref3.state;

    commit({
      type: 'querySentence',
      queryStr: payload.queryStr
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'list',
  props: {
    ds_name: {
      type: String,
      default: 'WNLI'
    },
    items: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    addLocation: function addLocation(text, ids) {
      ids.map(function (e) {
        text.splice(ids, 0, '@');
      });
      return text;
    }
  },
  filters: {
    subStr: function subStr(value) {
      var newVal = value.replace(/<.*?>/g, '');
      return newVal.slice(0, 400) + '...';
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'header-bar',
  data: function data() {
    return {
      showOptions: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    dataset: function dataset(state) {
      return state.docs.dataset;
    },
    datasets: function datasets(state) {
      return state.docs.datasets;
    }
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['loadDataset']), {
    showTalion: function showTalion() {
      this.$emit('showTalion');
    },
    onShowOptions: function onShowOptions() {
      this.showOptions = true;
    },
    onLoadOption: function onLoadOption(d) {
      this.showOptions = false;
    }
  })
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DList__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_DList__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home-view',
  components: { DList: __WEBPACK_IMPORTED_MODULE_3__components_DList___default.a, InfiniteLoading: __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default.a },
  data: function data() {
    return {
      queryStr: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    data: function data(state) {
      return state.docs.data;
    },
    dataset: function dataset(state) {
      return state.docs.dataset;
    },
    noMore: function noMore(state) {
      return state.docs.noMore;
    }
  })),
  watch: {
    '$route': function $route(to, from) {
      var name = this.$route.query.dataset || 'WNLI';
      this.loadDataset({ name: name });
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['loadDataset', 'loadMoreRows']), {
    query: function query() {
      if (this.queryStr.length === 0) {
        this.loadDataset({ name: this.dataset });
        return;
      }
      if (this.queryStr) {
        this.$store.dispatch({
          type: 'querySentence',
          queryStr: this.queryStr
        });
      }
    },
    onLoadMore: function onLoadMore() {
      this.loadMoreRows();
    }
  }),
  created: function created() {
    var name = this.$route.query.dataset || 'WNLI';
    this.loadDataset({ name: name });
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_HeaderBar__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_HeaderBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_HeaderBar__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pages-view',
  components: { HeaderBar: __WEBPACK_IMPORTED_MODULE_0__components_HeaderBar___default.a },
  data: function data() {
    return {
      talion: ''
    };
  },

  methods: {
    open: function open() {
      this.talion = 'open';
    },
    close: function close() {
      this.talion = '';
    }
  }
});

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 59 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 60 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 61 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 62 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(61)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(78),
  /* scopeId */
  "data-v-5d5ae216",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(59)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(76),
  /* scopeId */
  "data-v-1cf8493a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(58)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(27),
  /* template */
  __webpack_require__(75),
  /* scopeId */
  "data-v-015f255c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(60)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(28),
  /* template */
  __webpack_require__(77),
  /* scopeId */
  "data-v-449224cb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-view has-header"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "ui category search"
  }, [_c('div', {
    staticClass: "ui icon input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim.lazy",
      value: (_vm.queryStr),
      expression: "queryStr",
      modifiers: {
        "trim": true,
        "lazy": true
      }
    }],
    staticClass: "prompt",
    attrs: {
      "type": "text",
      "name": "query",
      "placeholder": "Search sentences... (at least 3 chars)"
    },
    domProps: {
      "value": (_vm.queryStr)
    },
    on: {
      "change": function($event) {
        _vm.queryStr = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "search icon"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.query()
      }
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('div', {
    staticClass: "results"
  })])]), _vm._v(" "), [_c('div', {
    staticClass: "about"
  }, [(_vm.$route.query.dataset == 'DPR') ? [_c('a', {
    attrs: {
      "href": "https://aclweb.org/anthology/papers/I/I17/I17-1100/"
    }
  }, [_vm._v("About This Task")])] : (_vm.$route.query.dataset == 'CMRC') ? [_c('a', {
    attrs: {
      "href": "https://github.com/ymcui/cmrc2018"
    }
  }, [_vm._v("About This Task")])] : (_vm.$route.query.dataset == 'DRCD') ? [_c('a', {
    attrs: {
      "href": "https://github.com/DRCKnowledgeTeam/DRCD"
    }
  }, [_vm._v("About This Task")])] : (_vm.$route.query.dataset == 'COPA') ? [_c('a', {
    attrs: {
      "href": "http://people.ict.usc.edu/~gordon/copa.html"
    }
  }, [_vm._v("About This Task")])] : (_vm.$route.query.dataset == 'MultiRC') ? [_c('a', {
    attrs: {
      "href": "https://cogcomp.seas.upenn.edu/multirc/"
    }
  }, [_vm._v("About This Task")])] : (_vm.$route.query.dataset == 'WiC') ? [_c('a', {
    attrs: {
      "href": "https://pilehvar.github.io/wic/"
    }
  }, [_vm._v("About This Task")])] : (_vm.$route.query.dataset == 'WNLI') ? [_c('a', {
    attrs: {
      "href": "https://cs.nyu.edu/faculty/davise/papers/WinogradSchemas/WS.html"
    }
  }, [_vm._v("About This Task")])] : (_vm.$route.query.dataset == 'ReCoRD') ? [_c('a', {
    attrs: {
      "href": "https://sheng-z.github.io/ReCoRD-explorer/"
    }
  }, [_vm._v("About This Task")])] : (_vm.$route.query.dataset == 'BoolQ') ? [_c('a', {
    attrs: {
      "href": "https://github.com/google-research-datasets/boolean-questions"
    }
  }, [_vm._v("About This Task")])] : (_vm.$route.query.dataset == 'RACE') ? [_c('a', {
    attrs: {
      "href": "http://www.qizhexie.com/data/RACE_leaderboard"
    }
  }, [_vm._v("About This Task")])] : (_vm.$route.query.dataset == 'SciTail') ? [_c('a', {
    attrs: {
      "href": "https://leaderboard.allenai.org/scitail/submissions/get-started"
    }
  }, [_vm._v("About This Task")])] : (_vm.$route.query.dataset == 'Winogrande') ? [_c('p', [_vm._v("A new collection of Winograd Schema Challenge (WSC) problems that are adversarially constructed to be robust against spurious statistical biases. It includes 43,985 instances, half of which are determined as adversarial. A new adversarial filtering algorithm AfLite for systematic bias reduction, combined with a careful crowdsourcing design. The performance of existing state-of-the-art methods remains modest (61.6%) and contrasts with high human performance (90.8%) for the binary questions.")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://leaderboard.allenai.org/winogrande/submissions/get-started"
    }
  }, [_vm._v("About This Task")])] : (_vm.$route.query.dataset == 'swag') ? [_c('a', {
    attrs: {
      "href": "https://rowanzellers.com/swag/"
    }
  }, [_vm._v("About This Task")])] : [_c('a', {
    attrs: {
      "href": "https://gluebenchmark.com/tasks"
    }
  }, [_vm._v("About This Task")])]], 2)], _vm._v(" "), _c('d-list', {
    attrs: {
      "ds_name": _vm.dataset,
      "items": _vm.data
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "block-button",
    on: {
      "click": _vm.onLoadMore
    }
  }, [_vm._v("More")])], 2)
},staticRenderFns: []}

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-bar"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'HomeView'
      }
    }
  }, [_vm._v("\n      NLP Dataset Explorer\n    ")])], 1), _vm._v(" "), (_vm.showOptions) ? _c('ul', {
    staticClass: "nav-options"
  }, [_vm._l((_vm.datasets), function(d) {
    return [_c('li', {
      on: {
        "click": _vm.onLoadOption
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'HomeView',
          query: {
            dataset: d
          }
        }
      }
    }, [_vm._v(_vm._s(d))])], 1)]
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.showOptions) ? _c('ul', {
    staticClass: "nav"
  }, [_c('li', [_vm._v(_vm._s(_vm.dataset))])]) : _vm._e(), _vm._v(" "), (!_vm.showOptions) ? _c('ul', {
    staticClass: "nav-more"
  }, [_c('li', {
    on: {
      "click": _vm.onShowOptions
    }
  }, [_vm._v("More")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-view"
  }, [_c('header-bar', {
    on: {
      "showTalion": _vm.open
    }
  }), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "footer"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-list"
  }, [(_vm.ds_name === 'WNLI') ? [_c('table', {
    staticClass: "ui celled table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "col-index"
  }, [_vm._v(_vm._s(_vm.items[0][0]))]), _vm._v(" "), _c('th', {
    staticClass: "col-label"
  }, [_vm._v(_vm._s(_vm.items[0][3]))]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v(_vm._s(_vm.items[0][1]))]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v(_vm._s(_vm.items[0][2]))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.items.slice(1)), function(item, index) {
    return [_c('tr', [_c('td', {
      staticClass: "col-index"
    }, [_vm._v(_vm._s(item[0]))]), _vm._v(" "), _c('td', {
      staticClass: "col-label"
    }, [_vm._v(_vm._s(item[3]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[1]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[2]))])])]
  })], 2)])] : _vm._e(), _vm._v(" "), (_vm.ds_name === 'DIAGNOSTICS') ? [_c('table', {
    staticClass: "ui celled table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "col-index"
  }, [_vm._v("Index")]), _vm._v(" "), _c('th', {
    staticClass: "col-index"
  }, [_vm._v(_vm._s(_vm.items[0][1]))]), _vm._v(" "), _c('th', {
    staticClass: "col-label"
  }, [_vm._v(_vm._s(_vm.items[0][7]))]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v(_vm._s(_vm.items[0][5]))]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v(_vm._s(_vm.items[0][6]))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.items.slice(1)), function(item, index) {
    return [_c('tr', [_c('td', {
      staticClass: "col-index"
    }, [_vm._v(_vm._s(index))]), _vm._v(" "), _c('td', {
      staticClass: "col-index"
    }, [_vm._v(_vm._s(item[1]))]), _vm._v(" "), _c('td', {
      staticClass: "col-label"
    }, [_vm._v(_vm._s(item[7]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[5]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[6]))])])]
  })], 2)])] : _vm._e(), _vm._v(" "), (_vm.ds_name === 'QNLI') ? [_c('table', {
    staticClass: "ui celled table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "col-index"
  }, [_vm._v(_vm._s(_vm.items[0][0]))]), _vm._v(" "), _c('th', {
    staticClass: "col-label"
  }, [_vm._v(_vm._s(_vm.items[0][3]))]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v(_vm._s(_vm.items[0][1]))]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v(_vm._s(_vm.items[0][2]))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.items.slice(1)), function(item, index) {
    return [_c('tr', [_c('td', {
      staticClass: "col-index"
    }, [_vm._v(_vm._s(item[0]))]), _vm._v(" "), _c('td', {
      staticClass: "col-label"
    }, [_vm._v(_vm._s(item[3]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[1]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[2]))])])]
  })], 2)])] : _vm._e(), _vm._v(" "), (_vm.ds_name === 'QQP') ? [_c('table', {
    staticClass: "ui celled table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "col-index"
  }, [_vm._v(_vm._s(_vm.items[0][0]))]), _vm._v(" "), _c('th', {
    staticClass: "col-label"
  }, [_vm._v(_vm._s(_vm.items[0][5]))]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v(_vm._s(_vm.items[0][3]))]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v(_vm._s(_vm.items[0][4]))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.items.slice(1)), function(item, index) {
    return [_c('tr', [_c('td', {
      staticClass: "col-index"
    }, [_vm._v(_vm._s(item[0]))]), _vm._v(" "), _c('td', {
      staticClass: "col-label"
    }, [_vm._v(_vm._s(item[5]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[3]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[4]))])])]
  })], 2)])] : _vm._e(), _vm._v(" "), (_vm.ds_name === 'RTE') ? [_c('table', {
    staticClass: "ui celled table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "col-index"
  }, [_vm._v(_vm._s(_vm.items[0][0]))]), _vm._v(" "), _c('th', {
    staticClass: "col-label"
  }, [_vm._v(_vm._s(_vm.items[0][3]))]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v(_vm._s(_vm.items[0][1]))]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v(_vm._s(_vm.items[0][2]))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.items.slice(1)), function(item, index) {
    return [_c('tr', [_c('td', {
      staticClass: "col-index"
    }, [_vm._v(_vm._s(item[0]))]), _vm._v(" "), _c('td', {
      staticClass: "col-label"
    }, [_vm._v(_vm._s(item[3]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[1]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[2]))])])]
  })], 2)])] : _vm._e(), _vm._v(" "), (_vm.ds_name === 'SST-2') ? [_c('table', {
    staticClass: "ui celled table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "col-index"
  }, [_vm._v("Index")]), _vm._v(" "), _c('th', {
    staticClass: "col-label"
  }, [_vm._v(_vm._s(_vm.items[0][1]))]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v(_vm._s(_vm.items[0][0]))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.items.slice(1)), function(item, index) {
    return [_c('tr', [_c('td', {
      staticClass: "col-label"
    }, [_vm._v(_vm._s(index))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[1]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[0]))])])]
  })], 2)])] : _vm._e(), _vm._v(" "), (_vm.ds_name === 'STS-B') ? [_c('table', {
    staticClass: "ui celled table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "col-index"
  }, [_vm._v(_vm._s(_vm.items[0][0]))]), _vm._v(" "), _c('th', {
    staticClass: "col-label"
  }, [_vm._v(_vm._s(_vm.items[0][9]))]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v(_vm._s(_vm.items[0][7]))]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v(_vm._s(_vm.items[0][8]))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.items.slice(1)), function(item, index) {
    return [_c('tr', [_c('td', {
      staticClass: "col-index"
    }, [_vm._v(_vm._s(item[0]))]), _vm._v(" "), _c('td', {
      staticClass: "col-label"
    }, [_vm._v(_vm._s(item[9]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[7]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[8]))])])]
  })], 2)])] : _vm._e(), _vm._v(" "), (_vm.ds_name === 'DPR') ? [_c('table', {
    staticClass: "ui celled table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.items), function(item, index) {
    return [_c('tr', [_c('td', {
      staticClass: "col-index"
    }, [_vm._v(_vm._s(item[1]))]), _vm._v(" "), _c('td', {
      staticClass: "col-label"
    }, [_vm._v(_vm._s(item[4]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[2]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[3]))])])]
  })], 2)])] : _vm._e(), _vm._v(" "), (_vm.ds_name === 'CB' || _vm.ds_name === 'RTE-DIAGNOSTIC') ? [_c('table', {
    staticClass: "ui celled table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.items), function(item, index) {
    return [_c('tr', [_c('td', {
      staticClass: "col-index"
    }, [_vm._v(_vm._s(item['idx']))]), _vm._v(" "), _c('td', {
      staticClass: "col-label"
    }, [_vm._v(_vm._s(item['label']))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item['premise']))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item['hypothesis']))])])]
  })], 2)])] : _vm._e(), _vm._v(" "), (_vm.ds_name === 'COPA') ? [_c('table', {
    staticClass: "ui celled table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_vm._l((_vm.items), function(item, index) {
    return [_c('tr', [_c('td', {
      staticClass: "col-index"
    }, [_vm._v(_vm._s(item['idx']))]), _vm._v(" "), _c('td', {
      staticClass: "col-label"
    }, [_vm._v(_vm._s(item['label']))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item['premise']))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item['choice1']))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item['choice2']))])])]
  })], 2)])] : _vm._e(), _vm._v(" "), (_vm.ds_name === 'WIC') ? [_c('table', {
    staticClass: "ui celled table"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [_vm._l((_vm.items), function(item, index) {
    return [_c('tr', [_c('td', {
      staticClass: "col-index"
    }, [_vm._v(_vm._s(item['idx']))]), _vm._v(" "), _c('td', {
      staticClass: "col-label"
    }, [_vm._v(_vm._s(item['word']))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item['label']))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item['sentence1'].replace(item['word'], ("[" + (item['word']) + "]"))))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item['sentence2'].replace(item['word'], ("[" + (item['word']) + "]"))))])])]
  })], 2)])] : _vm._e(), _vm._v(" "), (_vm.ds_name === 'BOOLQ') ? [_c('table', {
    staticClass: "ui celled table"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', [_vm._l((_vm.items), function(item, index) {
    return [_c('tr', [_c('td', {
      staticClass: "col-index"
    }, [_vm._v(_vm._s(item['idx']))]), _vm._v(" "), _c('td', {
      staticClass: "col-label"
    }, [_vm._v(_vm._s(item['label']))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item['passage']))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item['question']))])])]
  })], 2)])] : _vm._e(), _vm._v(" "), _vm._l((_vm.items), function(item, index) {
    return (_vm.ds_name === 'CMRC' || _vm.ds_name === 'DRCD') ? [_c('div', {
      staticClass: "row-block"
    }, [_c('h2', {
      staticClass: "ui horizontal divider header"
    }, [_c('i', {
      staticClass: "file outline icon"
    }), _vm._v("\n        " + _vm._s(item['title']) + "\n      ")]), _vm._v(" "), _vm._l((item['paragraphs']), function(row, ri) {
      return [_c('div', {
        staticClass: "paragraph"
      }, [_c('p', [_vm._v(_vm._s(row['context']))]), _vm._v(" "), _vm._m(5, true), _vm._v(" "), _vm._l((row['qas']), function(q, qi) {
        return _c('div', [_c('p', {
          staticClass: "question"
        }, [_vm._v(_vm._s(q['question']))]), _vm._v(" "), _c('div', {
          staticClass: "answers"
        }, _vm._l((q['answers']), function(a, ai) {
          return _c('span', {
            staticClass: "answer"
          }, [_vm._v("\n                " + _vm._s(ai + 1) + ": " + _vm._s(a['text'])), _c('span', [_vm._v("(" + _vm._s(a['answer_start']) + ")")]), _vm._v("    \n              ")])
        }), 0)])
      })], 2)]
    })], 2)] : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.items), function(item, index) {
    return (_vm.ds_name === 'MULTIRC') ? [_c('div', {
      staticClass: "row-block"
    }, [_c('div', {
      staticClass: "paragraph"
    }, [_c('div', {}, [_c('p', [_vm._v(_vm._s(item['passage']['text']))])]), _vm._v(" "), _vm._m(6, true), _vm._v(" "), _vm._l((item['passage']['questions']), function(row, ri) {
      return [_c('div', {
        staticClass: "question"
      }, [_c('p', [_vm._v(_vm._s(row['question']))]), _vm._v(" "), _c('div', {
        staticClass: "answers"
      }, _vm._l((row['answers']), function(a, ai) {
        return _c('div', {
          staticClass: "statement"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (a.label),
            expression: "a.label"
          }],
          staticClass: "annotate-id",
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": Array.isArray(a.label) ? _vm._i(a.label, null) > -1 : (a.label)
          },
          on: {
            "change": function($event) {
              var $$a = a.label,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(a, "label", $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(a, "label", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(a, "label", $$c)
              }
            }
          }
        }), _vm._v(" "), _c('label', [_vm._v(_vm._s(a['text']))])])
      }), 0)])]
    })], 2)])] : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.items), function(item, index) {
    return (_vm.ds_name === 'RECORD') ? [_c('div', {
      staticClass: "row-block"
    }, [_c('div', {
      staticClass: "paragraph"
    }, [_c('h2', {
      staticClass: "ui horizontal divider header"
    }, [_c('i', {
      staticClass: "file outline icon"
    }), _vm._v("\n          " + _vm._s(item['source']) + "\n        ")]), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v(_vm._s(item['passage']['text']))])]), _vm._v(" "), _vm._m(7, true), _vm._v(" "), _vm._l((item['qas']), function(row, ri) {
      return [_c('div', {
        staticClass: "question"
      }, [_c('p', [_vm._v(_vm._s(row['query']))]), _vm._v(" "), _c('div', {
        staticClass: "answers"
      }, _vm._l((row['answers']), function(a, ai) {
        return _c('span', {
          staticClass: "answer"
        }, [_c('div', [_vm._v(_vm._s(a['text']))]), _c('div', {
          staticClass: "annotate-id"
        }, [_vm._v(_vm._s(a['label']))])])
      }), 0)])]
    })], 2)])] : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.items), function(item, index) {
    return (_vm.ds_name === 'RACE') ? [_c('div', {
      staticClass: "row-block"
    }, [_c('div', {
      staticClass: "paragraph"
    }, [_c('div', {}, [_c('p', [_vm._v(_vm._s(item['article']))])]), _vm._v(" "), _vm._m(8, true), _vm._v(" "), _vm._l((item['questions']), function(q, qi) {
      return [_c('div', {
        staticClass: "questions"
      }, [_c('div', {}, [_vm._v(_vm._s(q) + " "), _c('span', {
        staticClass: "answer"
      }, [_vm._v(_vm._s(item['answers'][qi]))])]), _vm._v(" "), _c('div', {
        staticClass: "options"
      }, _vm._l((item['options'][qi]), function(opt, opti) {
        return _c('span', {
          staticClass: "option"
        }, [_c('div', [_vm._v(_vm._s(['A)', 'B)', 'C)', 'D)'][opti]) + " " + _vm._s(opt))])])
      }), 0)])]
    })], 2)])] : _vm._e()
  }), _vm._v(" "), (_vm.ds_name === 'SCITAIL') ? [_c('table', {
    staticClass: "ui celled table"
  }, [_vm._m(9), _vm._v(" "), _c('tbody', [_vm._l((_vm.items.slice(1)), function(item, index) {
    return [_c('tr', [_c('td', {
      staticClass: "col-index"
    }, [_vm._v(_vm._s(index))]), _vm._v(" "), _c('td', {
      staticClass: "col-label"
    }, [_vm._v(_vm._s(item[2]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[0]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[1]))])])]
  })], 2)])] : _vm._e(), _vm._v(" "), (_vm.ds_name === 'WINOGRANDE') ? [_c('table', {
    staticClass: "ui celled table"
  }, [_vm._m(10), _vm._v(" "), _c('tbody', [_vm._l((_vm.items.slice(1)), function(item, index) {
    return [_c('tr', [_c('td', {
      staticClass: "col-index"
    }, [_vm._v(_vm._s(index))]), _vm._v(" "), _c('td', {
      staticClass: "col-label"
    }, [_vm._v(_vm._s(("" + (item['option1']) + (item['answer']==='1'?'(x)':'') + ", " + (item['option2']) + (item['answer']==='2'?'(x)':''))))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item['sentence']))])])]
  })], 2)])] : _vm._e(), _vm._v(" "), _vm._l((_vm.items.slice(1)), function(item, index) {
    return (_vm.ds_name === 'SWAG') ? [_c('div', {
      staticClass: "row-block"
    }, [_c('div', {
      staticClass: "question"
    }, [_c('p', [_vm._v(_vm._s(item[2]) + "...")]), _vm._v(" "), _c('div', {
      staticClass: "options"
    }, [_c('div', {
      staticClass: "option gold"
    }, [_vm._v(_vm._s(item[3]))]), _vm._v(" "), _c('div', {
      staticClass: "option"
    }, [_vm._v(_vm._s(item[4]))]), _vm._v(" "), _c('div', {
      staticClass: "option"
    }, [_vm._v(_vm._s(item[5]))]), _vm._v(" "), _c('div', {
      staticClass: "option"
    }, [_vm._v(_vm._s(item[6]))]), _vm._v(" "), _c('div', {
      staticClass: "option"
    }, [_vm._v(_vm._s(item[7]))])])])])] : _vm._e()
  }), _vm._v(" "), (_vm.ds_name === 'basic') ? [_c('ul', {
    staticClass: "basic"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('h3', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_vm._v(_vm._s(item.summary))])])])
  }), 0)] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "col-index"
  }, [_vm._v("Index")]), _vm._v(" "), _c('th', {
    staticClass: "col-label"
  }, [_vm._v("Label")]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v("Premise")]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v("Hypothesis")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "col-index"
  }, [_vm._v("Index")]), _vm._v(" "), _c('th', {
    staticClass: "col-label"
  }, [_vm._v("Label")]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v("Premise")]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v("Hypothesis")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "col-index"
  }, [_vm._v("Index")]), _vm._v(" "), _c('th', {
    staticClass: "col-label"
  }, [_vm._v("Label")]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v("Premise")]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v("Choice 1")]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v("Choice 2")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "col-index"
  }, [_vm._v("Index")]), _vm._v(" "), _c('th', {
    staticClass: "col-label"
  }, [_vm._v("Word")]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v("Label")]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v("Sentence 1")]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v("Sentence 2")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "col-index"
  }, [_vm._v("Index")]), _vm._v(" "), _c('th', {
    staticClass: "col-label"
  }, [_vm._v("Label")]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v("Passage")]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v("Question")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "ui horizontal divider header"
  }, [_c('i', {
    staticClass: "question circle outline icon"
  }), _vm._v("\n            Questions\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "ui horizontal divider header"
  }, [_c('i', {
    staticClass: "question circle outline icon"
  }), _vm._v("\n          Questions\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "ui horizontal divider header"
  }, [_c('i', {
    staticClass: "question circle outline icon"
  }), _vm._v("\n          Questions\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "ui horizontal divider header"
  }, [_c('i', {
    staticClass: "question circle outline icon"
  }), _vm._v("\n          Questions\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "col-index"
  }, [_vm._v("Index")]), _vm._v(" "), _c('th', {
    staticClass: "col-label"
  }, [_vm._v("Label")]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v("Sentence 1")]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v("Sentence 2")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "col-index"
  }, [_vm._v("Index")]), _vm._v(" "), _c('th', {
    staticClass: "col-label"
  }, [_vm._v("Label")]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v("Sentence")])])])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    staticClass: "view"
  }), _vm._v(" "), _c('router-view', {
    staticClass: "view",
    attrs: {
      "name": "subject"
    }
  }), _vm._v(" "), _c('router-view', {
    staticClass: "view",
    attrs: {
      "name": "search"
    }
  })], 1)
},staticRenderFns: []}

/***/ })
],[22]);


// WEBPACK FOOTER //
// static/js/app.c3f8a7de64181291945f.js